/**
 * Full Screen Loading
 */

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { keyframes } from '@mui/material/styles';

const pulse = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
`;

const bounce = keyframes`
  0%, 80%, 100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
`;

export interface LoadingScreenProps {
    message?: string;
}

/**
 * Full-screen loading indicator.
 * Used for initial app load and route transitions.
 */
export function LoadingScreen({ message = 'Loading...' }: LoadingScreenProps) {
    return (
        <Box
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                bgcolor: 'background.default',
                zIndex: 9999,
            }}
        >
            <Box
                sx={{
                    width: 60,
                    height: 60,
                    borderRadius: 2,
                    background: theme =>
                        `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 20,
                    fontWeight: 700,
                    color: 'white',
                    mb: 3,
                    animation: `${pulse} 2s ease-in-out infinite`,
                }}
            >
                AC
            </Box>

            <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
                {[0, 1, 2].map(i => (
                    <Box
                        key={i}
                        sx={{
                            width: 8,
                            height: 8,
                            borderRadius: '50%',
                            bgcolor: 'primary.main',
                            animation: `${bounce} 1.4s ease-in-out infinite`,
                            animationDelay: `${i * 0.16}s`,
                        }}
                    />
                ))}
            </Box>

            <Typography variant="body2" color="text.secondary">
                {message}
            </Typography>
        </Box>
    );
}


